// extracted by mini-css-extract-plugin
export default {"container":"yp-z","ratingLayout":"zp-z","ratingLabel":"Ap-z","nonInteractiveRatingLabel":"Bp-z"};